import React, { useState, useEffect, useRef } from 'react';
import { View, Image, Text, TouchableOpacity, ScrollView } from 'react-native';
import { LinearGradient } from "expo-linear-gradient";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useIsFocused } from '@react-navigation/native';
import * as Print from 'expo-print';
import { shareAsync } from 'expo-sharing';
import QRCode from 'react-native-qrcode-svg';
import logo from '../../../assets/imgs/gpxcarbo_small.jpg';
import Carbo from '../../svgs/Carbo';

import iconsFooter from '../../../assets/imgs/certificateIconFooter.png'
import moment from "moment";
import 'moment/locale/pt-br'

import api from '../../services/api';
import HeaderTabs from '../../components/HeaderTabs';

import styles from "./styles";

const CertificatesEmit = ({ navigation, route }) => {
    moment.locale('pt-br');
    const now = moment().format('LLL');

    const ref = useRef(null);
    const [value, setValue] = useState(route.params.idCoin);
    const [volume, setVolume] = useState(route.params.volume);
    const [valueToken, setValueToken] = useState(route.params.qtd);
    const [year, setYear] = useState(route.params.year);
    const [name, setName] = useState('');
    const [certificateUuid, setCertificateUuid] = useState('');
    const [qrcodeImage64, setQrcodeImage64] = useState('');

    const isFocused = useIsFocused();
    useEffect(() => {
        getCertificates();
        getDataUsers();
    }, []);



    const getCertificates = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        var body = {
            idCoin: value,
            qtd: valueToken,
            year: year
        }

        api.post('certificates', body, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                if (res.data.uuid) {
                    setCertificateUuid(res.data.uuid);
                }
            })
            .catch((error) => {
                //console.log("erro certificado", error);
                //console.log("erro certificado", error.response);
            })

    }

    const getDataUsers = async () => {

        const token = await AsyncStorage.getItem('JWT_TOKEN');

        api.get(`/clients/getDetails/client`, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                // console.log(res.data)
                if (res.data.user[0].client.last_name) {
                    setName(`${res.data.user[0].client.first_name} ${res.data.user[0].client.last_name}`)
                } else {
                    setName(`${res.data.user[0].client.first_name}`)
                }
            })
            .catch((error) => {
                toast("Houve um erro, tente novamente.", "#DA1414");
            })
    }

    let svg = ''

    const HtmlCertificate = () => {
        function getDataURL() {
            return svg.toDataURL(callback);
        }
        function callback(dataURL) {
            setQrcodeImage64(dataURL)
        }
        useEffect(() => {
            //   getDataURL()
        }, [])
        return (
            <View key={5} style={styles.container}>
                <View key={6} style={styles.view}>
                    <Image source={logo} style={styles.image2} />
                    <Text key={1} style={styles.label}>Certificado de Neutralização</Text>
                    <View style={styles.hr}></View>
                    <Text key={2} style={styles.label1}>GPX Tecnologia e Investimento por meio do programa de gerenciamento de gases do efeito estufa, confere o Certificado de Neutralização de Carbono à: </Text>
                    <Text key={3} style={styles.label}>{name}</Text>

                    <Text key={4} style={styles.label2}>No total foram neutralizados {valueToken * 1000}kg de CO² ({valueToken} crédito(s) de carbono) referente(s) ao ano de {year}.</Text>
                    <Text key={5} style={styles.label3}> Florianópolis, {now}</Text>

                    <View style={styles.signature}>
                        <Image source={{uri: 'https://filesgpx.s3.us-east-2.amazonaws.com/static/assinatura_transparente.png'}} style={styles.signatureImg} />
                        <View style={styles.signatureLine}></View>
                        <Text>GPX Tecnologia e Investimento</Text>
                    </View>
                    <Text>Código do Certificado</Text>
                    <Text style={styles.green}>{certificateUuid}</Text>
                    <View style={styles.footer}>
                        <QRCode size={55} getRef={c => (svg = c)} value={`http://api.gpxexchange.com.br/certificates/view/${certificateUuid}`} />
                        <Image style={styles.iconsFooter} source={iconsFooter} />
                    </View>
                    <View style={styles.backgroundImage}>
                        <Carbo width={400} height={400} />
                    </View>
                </View>
            </View>
        );
    }


    const Baixar = () => {
        return <>
            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={printToFile}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}>Download</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    }
    const Fechar = () => {
        return <>
            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={() => navigation.navigate('Tabs')}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}>Fechar</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>

    }
    const printToFile = async () => {

        const html = `
        <body
        style="background: url(https://docs.google.com/uc?export=download&id=1vTRq0ZqHA2RzwH-ThRZy4nzSSQAg_LYb) no-repeat center center; background-size:cover;font-family: Arial; color:#333; margin:0;padding:0">
              <div style="display:flex; padding-left:15px; padding-right:15px; justify-content:center;">
          <div
            style=" width: 100%; position:relative; overflow:hidden; margin: 50px; background-color: #fff; border: 1px solid #ccc; text-align: center;">
            <img style="width:80%; max-width:800px;position: absolute; top:50%; left:50%;transform: translate(-50%, -50%);"
              src="https://docs.google.com/uc?export=download&id=1Rx5sxmpMTWJEW-XMaKfPnDMe9sOiJUfw" alt="background logo" />
            <img src="https://docs.google.com/uc?export=download&id=1nPTufSlCjoPua3mEFEnHd497vlUzZGEQ" width=220
              style="margin-top:30; margin-bottom:30;margin-left:auto;margin-right:auto;" />
            <h1
              style="font-weight:normal; margin:0;font-family: Georgia; font-size:280%; margin-bottom:20px; text-align:center; ">
              CERTIFICADO DE NEUTRALIZAÇÃO</h1>
            <hr style="width:50%; border-bottom: 2px;" />
            <p style="width:60%;font-family: Arial; font-size: 14px; text-align: center; margin: 30 auto;">
              GPX
              Tecnologia e Investimento por meio do programa de gerenciamento de gases do efeito estufa, confere o
              Certificado
              de Neutralização de Carbono à: </p>
            <p
              style="font-family: Georgia;font-size: 250%;margin-bottom: 20px;margin-top: 20px;text-align: center; font-weight: normal;">
              ${name}
            </p>
            <br>
            <p
              style="font-size: 14px; margin-top:0; margin-bottom:0; margin-left: 15px; margin-right: 15px;text-align: center;">
              No total
              foram
              neutralizados
              ${valueToken * 1000}kg de CO² (${valueToken} crédito(s) de carbono) referente(s) ao ano de ${year}.</p>
            <p style="font-size:14px; margin-bottom:15px; margin-left: 15px;margin-right: 15px;text-align: center;">
              Florianópolis, ${now}</p>
            <div
              style="margin:0 auto; max-width:800px; display: flex; flex-direction: row; justify-content: space-around; align-items: center;">
              <div style="margin: 0 30">
                <img src="https://filesgpx.s3.us-east-2.amazonaws.com/static/assinatura_transparente.png" style="max-width: 80%; max-height: 45px; width: auto; height: auto; margin: 0 auto;"/>
                <hr style="width:228px; border-top:1px solid" />
                <p style="font-size: 14px;">GPX Tecnologia e Investimento</p>
              </div>
              <img src="https://docs.google.com/uc?export=download&id=1g8aiEXseQxLJIqJJVtnrvmAWqfBE_ks_" alt="carbon icon" />
              <div
                style="width:260px; font-size: 14px;margin-bottom: 15px;margin-left: 15px;margin-right: 15px;text-align: center;">
                <p>Código do Certificado<br>
                  <span style="color:#96B533">${certificateUuid}</span>
                </p>
              </div>
            </div>
                  <div style="height:60px; display: flex; flex-direction: row; justify-content: space-between; padding: 25px">
              <img style="width:60px; height:60px;" src="data:image/jpeg;base64,${qrcodeImage64}" />
              <img style="width: 190px;align-self: end;"
                src="https://docs.google.com/uc?export=download&id=1kvvp4w16Ob6FHL1zajxon4m-HBk0l2q4" alt="icons" />
            </div>
          </div>
        </div>
      </body>
        `;
        // On iOS/android prints the given html. On web prints the HTML from the current page.
        Print.Orientation.portrait
        await Print.printToFileAsync({
            orientation: Print.Orientation.landscape,
            html: html
        });
        //console.log('File has been saved to:', uri);
        //await shareAsync(uri, { UTI: '.pdf', mimeType: 'application/pdf' });
    }


    return (
        <>
            <HeaderTabs
                title={"Emissão de Certificado"}
                iconLeft={"settings"}
                routeLeft={"MyAccount"}
                subtitle={"Certificado de Neutralização de Carbono"}
            />
            <ScrollView style={{ flex: 1 }}>
                <HtmlCertificate />
            </ScrollView>
            <View style={{ paddingVertical: 15, flexDirection: 'row', justifyContent: 'space-between' }}>
                <Baixar />
                <Fechar />
            </View>
        </>
    );
}

export default CertificatesEmit;